module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/pigmy-creation-grid/pigmy-creation-grid.component.css
// module id = ./src/app/master-account/pigmy-creation-grid/pigmy-creation-grid.component.css
// module chunks = main